import sanitizeInput from "./senetizeInput";

const { Form, InputGroup } = require("react-bootstrap");

const InputFormControl = ({
    customClass,
    type,
    name,
    placeholder,
    value,
    handleChange,
    isInvalid,
    groupText1,
    handleBlur,
    isDisabled
}) => {
  const handleInputChange = (e) => {
    const sanitizedValue = sanitizeInput(e.target.value);
    const sanitizedEvent = {
      ...e,
      target: {
        name:e.target.name,
        value: sanitizedValue,
      },
    };
    handleChange(sanitizedEvent);
  };
  return (
    <InputGroup>
    {groupText1}
    <Form.Control
      className={`form-control ${customClass} ${isDisabled ? 'disabled-field':""}`}
      type={type || "text"}
      placeholder={placeholder}
      name={name}
      value={value}
      disabled={isDisabled}
      isInvalid={isInvalid}
      onChange={handleInputChange}
      onBlur={handleBlur}
    />
    </InputGroup>
  );
};

export default InputFormControl;
